function initCartNotificationSwiper() {
  const cartNotificationSlider = document.querySelector(".cart-notification");

  if (cartNotificationSlider) {
    const swiperContainer = cartNotificationSlider.querySelector(
      ".cart-notification-products-swiper"
    );

    if (swiperContainer && !swiperContainer.classList.contains('swiper-initialized')) {
      // Check if there are slides to initialize swiper
      const slides = swiperContainer.querySelectorAll('.swiper-slide');
      
      if (slides.length > 0) {
        new Swiper(swiperContainer, {
          loop: false,
          slidesPerView: 2,
          spaceBetween: 10,
          navigation: {
            nextEl: ".cart-notification-next",
            prevEl: ".cart-notification-prev",
          },
          breakpoints: {
            990: {
              slidesPerView: 3,
            },
          },
        });
        
        swiperContainer.classList.add('swiper-initialized');
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  initCartNotificationSwiper();
  
  // Initialize click-outside functionality with event prevention
  initCartNotificationClickOutside();
});

// Click-outside functionality for cart notification with event prevention
function initCartNotificationClickOutside() {
  let clickOutsideHandler = null;
  let backdropClickHandler = null;
  
  // Listen for cart notification opening/closing
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const cartNotification = document.querySelector('cart-notification');
        const cartNotificationDiv = document.getElementById('cart-notification');
        
        // Check if cart notification became active
        const isActive = cartNotification?.classList.contains('active') || 
                        cartNotificationDiv?.classList.contains('active');
        
        if (isActive && !clickOutsideHandler) {
          // Handler to prevent clicks inside the notification from bubbling
          backdropClickHandler = (evt) => {
            const target = evt.target;
            
            // Allow close button clicks to work normally
            const isCloseButton = target.closest('.cart-notification__close') || 
                                target.closest('button[type="button"]');
            
            if (isCloseButton) {
              // Don't interfere with close button functionality
              return;
            }
            
            // Check if click is inside cart notification content
            const isInsideCartNotification = 
              target.closest('cart-notification') ||
              target.closest('.cart-notification') ||
              target.closest('#cart-notification') ||
              target.closest('.cart-notification-wrapper');
            
            if (isInsideCartNotification) {
              // Stop propagation to prevent clicks from reaching elements underneath
              evt.stopPropagation();
            }
          };
          
          // Main click-outside handler
          clickOutsideHandler = (evt) => {
            const target = evt.target;
            
            // Allow close button clicks to work normally
            const isCloseButton = target.closest('.cart-notification__close') || 
                                target.closest('button[type="button"]');
            
            if (isCloseButton) {
              // Don't interfere with close button functionality
              return;
            }
            
            // Check if click is outside cart notification
            const isInsideCartNotification = 
              target.closest('cart-notification') ||
              target.closest('.cart-notification') ||
              target.closest('#cart-notification') ||
              target.closest('.cart-notification-wrapper');
            
            // Close if clicking outside and prevent default behavior
            if (!isInsideCartNotification) {
              evt.preventDefault();
              evt.stopPropagation();
              
              const cartNotificationElement = document.querySelector('cart-notification');
              if (cartNotificationElement && typeof cartNotificationElement.close === 'function') {
                cartNotificationElement.close();
              } else {
                // Fallback: remove active classes manually
                cartNotification?.classList.remove('active');
                cartNotificationDiv?.classList.remove('active');
              }
            }
          };
          
          // Add handlers with a small delay to prevent immediate closing
          setTimeout(() => {
            // Add backdrop handler to capture and stop propagation
            document.body.addEventListener('click', backdropClickHandler, true);
            // Add main click-outside handler
            document.body.addEventListener('click', clickOutsideHandler, true);
          }, 100);
          
        } else if (!isActive && clickOutsideHandler) {
          // Remove click handlers when cart notification is closed
          document.body.removeEventListener('click', backdropClickHandler, true);
          document.body.removeEventListener('click', clickOutsideHandler, true);
          clickOutsideHandler = null;
          backdropClickHandler = null;
        }
      }
    });
  });
  
  // Observe changes to cart notification elements
  const cartNotification = document.querySelector('cart-notification');
  const cartNotificationDiv = document.getElementById('cart-notification');
  
  if (cartNotification) {
    observer.observe(cartNotification, { attributes: true, attributeFilter: ['class'] });
  }
  if (cartNotificationDiv) {
    observer.observe(cartNotificationDiv, { attributes: true, attributeFilter: ['class'] });
  }
}
